<template>
  <div>
    <HeaderReceipt header="แก้ไขข้อมูลใบส่งคืนสินค้า(CN)" :img_header="header_image" link_back="stock/storage/addproducttostock"/>
    <StorageCN_edit/>
  </div>
</template>

<script>
import HeaderReceipt from "@/components/admin/stock/menustorage/HeaderReceipt";
import HeaderImage from "@/assets/completed-task.png";
import StorageCN_edit from "@/components/admin/stock/cn/StorageCN_edit";
export default {
  name: "CnEdit",
  data() {
    return {
      header_image: HeaderImage
    }
  },
  components: {
    StorageCN_edit,
    HeaderReceipt
  }
}
</script>

<style scoped>

</style>
